export function requireElementById(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`element not found: #${id}`);
  return el;
}

export function requireElementOfType<T extends Element>(
  id: string,
  predicate: (el: Element) => el is T,
): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`element not found: #${id}`);
  if (!predicate(el)) throw new Error(`element type mismatch: #${id}`);
  return el;
}

export function requireQuerySelector(root: ParentNode, selector: string): Element {
  const el = root.querySelector(selector);
  if (!el) throw new Error(`element not found: ${selector}`);
  return el;
}

export function requireQuerySelectorHTML(root: ParentNode, selector: string): HTMLElement {
  const el = requireQuerySelector(root, selector);
  if (!(el instanceof HTMLElement)) {
    throw new Error(`element type mismatch: ${selector}`);
  }
  return el;
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (ch) => {
    switch (ch) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#39;';
      default:
        return ch;
    }
  });
}

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

export function fmtHms(input: Date | number | string | null): string {
  if (input === null) return '--:--:--';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '--:--:--';
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}

export function fmtHm(input: Date | number | string | null): string {
  if (input === null) return '--:--';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '--:--';
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

/** YYYY-MM-DD (JST date) の 05:00 JST を ms で返す。 */
export function jst5amMs(yyyymmdd: string): number {
  return new Date(`${yyyymmdd}T05:00:00+09:00`).getTime();
}

/** ms (UTC) → JST における暦日の YYYY-MM-DD 文字列。 */
export function jstDateStr(ms: number): string {
  const d = new Date(ms + 9 * 60 * 60 * 1000);
  return d.toISOString().slice(0, 10);
}

/** 今日の JST 暦日。 */
export function todayJstDateStr(): string {
  return jstDateStr(Date.now());
}

/** YYYY-MM-DD (JST) に days 日加算した YYYY-MM-DD を返す。 */
export function addDaysJst(yyyymmdd: string, days: number): string {
  const t = new Date(`${yyyymmdd}T00:00:00+09:00`).getTime();
  return jstDateStr(t + days * 86_400_000);
}

export function fnvHue(name: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < name.length; i++) {
    h = (h ^ name.charCodeAt(i)) >>> 0;
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h % 360;
}
